// extracted by mini-css-extract-plugin
module.exports = {"PageFAQBlock__inner":"PageFAQBlock_PageFAQBlock__inner__uMsER","PageFAQBlock__block":"PageFAQBlock_PageFAQBlock__block___FhrN"};